<div class="w-full max-w-xl">
    <div class="grid gap-8 sm:grid-flow-col xl:grid-flow-row">
        <!-- Previous statement -->
        <div class="relative flex flex-col flex-auto p-6 pr-3 pb-3 bg-card rounded-2xl shadow overflow-hidden">
            <div class="absolute bottom-0 right-0 w-24 h-24 -m-6">
                <mat-icon
                    class="icon-size-24 opacity-25 text-green-500 dark:text-green-400"
                    [svgIcon]="'heroicons_outline:check-circle'"
                ></mat-icon>
            </div>
            <div class="flex items-center">
                <div class="flex flex-col">
                    <div class="text-lg font-medium tracking-tight leading-6 truncate">
                        {{ 'label_access_role' | translatePlural }}
                    </div>
                    @if (user?.user?.timeStamp) {
                        <div class="text-green-600 font-medium text-sm">
                            {{
                                'info_last_updated_at'
                                    | translate
                                        : {
                                              date: user.user.timeStamp | date: 'dd.MM.YYYY kl. HH:mm',
                                          }
                            }}
                        </div>
                    }
                </div>
            </div>
            <div class="space-y-4 mt-[20px] mb-[20px] sm:mr-[20px]">
                @for (role of user.roles; track role) {
                    <div class="flex items-center justify-between">
                        <div class="flex-auto">
                            <div class="leading-6 font-medium">
                                {{ 'label_role_' + role.roleName | translate }}
                            </div>
                            <div class="text-md text-secondary">
                                {{ 'info_role_' + role.roleName | translate }}
                            </div>
                        </div>
                        <mat-slide-toggle class="ml-2" [color]="'primary'" [disabled]="true" [checked]="true"> </mat-slide-toggle>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
